import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["query", "empties", "list"]

  connect() {
    this.boundFilter = this.filter.bind(this)
    if (this.hasQueryTarget) {
      this.queryTarget.addEventListener("input", this.boundFilter)
      this.queryTarget.addEventListener("search", this.boundFilter)
      this.queryTarget.addEventListener("keyup", this.boundFilter)
      this.queryTarget.addEventListener("change", this.boundFilter)
    }
    if (this.hasEmptiesTarget) {
      this.emptiesTarget.addEventListener("change", this.boundFilter)
    }
    this.filter()
  }

  disconnect() {
    if (this.hasQueryTarget && this.boundFilter) {
      this.queryTarget.removeEventListener("input", this.boundFilter)
      this.queryTarget.removeEventListener("search", this.boundFilter)
      this.queryTarget.removeEventListener("keyup", this.boundFilter)
      this.queryTarget.removeEventListener("change", this.boundFilter)
    }
    if (this.hasEmptiesTarget && this.boundFilter) {
      this.emptiesTarget.removeEventListener("change", this.boundFilter)
    }
  }

  filter() {
    var query = this.hasQueryTarget ? this.queryTarget.value.trim().toLowerCase() : ""
    var showEmpties = this.hasEmptiesTarget && this.emptiesTarget.checked
    var cards = this.element.querySelectorAll(".wine-card")

    for (var i = 0; i < cards.length; i++) {
      var card = cards[i]
      var quantity = parseInt(card.dataset.quantity || "0", 10)
      var searchText = (card.dataset.search || "").toLowerCase()
      var matchesQuery = query === "" || searchText.indexOf(query) !== -1
      var matchesEmpties = showEmpties || quantity > 0
      var visible = matchesQuery && matchesEmpties

      card.classList.toggle("is-filtered-out", !visible)
      card.classList.toggle("show-empty", visible && quantity === 0)
      card.hidden = !visible
    }
  }
}
